import RequestSection from "../features/stock/RequestSection";
import StockMain from "../features/stock/StockMain";


const StockLayout = () => {

  return (
    <div style={{ width: "100%", display: "flex", maxHeight: "90vh",  }}>
      <div style={{ width: "72%", padding: "1.2vw 0px 0px 1.2vw",  }}>
        <StockMain />
      </div>
      <div style={{ width: "28%", borderLeft: "4px solid #0D0D0D", height: "90vh", overflowY: "auto" }}>
        <RequestSection />
      </div>
    </div>
  );
};

export default StockLayout;